{
  "dropzoneLabel": "Ablegebereich",
  "selectPlaceholder": "Element wählen",
  "tableResizer": "Größenanpassung"
}
